// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ctas-container[data-v-84a25454]>*{margin-top:.5rem}", "",{"version":3,"sources":["webpack://./resources/platform/assets/js/Components/_Collections/PageHeader/PageHeader.vue"],"names":[],"mappings":"AAEE,mCACE,gBADJ","sourcesContent":["\n.ctas-container {\n  ::v-deep>* {\n    margin-top: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
